import { render, staticRenderFns } from "./BatchReturn.vue?vue&type=template&id=9f421b96&scoped=true"
import script from "./BatchReturn.vue?vue&type=script&lang=js"
export * from "./BatchReturn.vue?vue&type=script&lang=js"
import style0 from "./BatchReturn.vue?vue&type=style&index=0&id=9f421b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f421b96",
  null
  
)

export default component.exports